import GameElement from '../../e.elements/GameElements/GameElement/GameElement'
import Grid from '../../e.elements/Grid/Grid'
import { useSceneStore } from '../../a.scenes/GameScene/store'
import { Tile } from '../../c.managers/TerrainManager/store.d'
import { Object3D, Vector2 } from 'three'
import { useScenesStore } from '../../b.providers/ScenesProvider/store'
import { coordsToPosition } from '../../e.elements/Grid/scripts/helpers/coordsPositionConverter'
import getGameElementByUUID from '../../e.elements/GameElements/helpers/getGameElementByUUID'
import { Gravestone } from '../../f.assets/Objects/components/Gravestone/Gravestone'
import { SEL_GRAVESTONES } from '../../c.managers/TerrainManager/selectors'
import { GameObject3D } from '../../e.elements/GameElements/classes/types'
import GameObject from '../../e.elements/GameElements/classes/GameObject'
import { GradientTexture } from '@react-three/drei'
import Electron from '../../e.elements/Electron/Electron'

export const API = {
  // updates given position for given object into gridElement as well as self userData.coords
  // also clears previous position intro gridElement
  moveObject: (obj: Object3D, target: Vector2) => {
    const grid = useScenesStore.getState().getGameElement('gridElement')
    const objIsInGrid = obj.userData.coords !== undefined
    let success = true
    if (objIsInGrid) {
      const tileSrc = grid?.userData.grid[obj.userData.coords.x][obj.userData.coords.y] as Tile
      tileSrc?.clearTile()
    }
    const tileTrg = grid?.userData.grid[target.x][target.y] as Tile
    if(tileTrg.elementId !== null) {
      console.warn(`Trying to allocate ${obj.uuid} but place is taken by ${tileTrg.elementId}`)
      success = false
      // throw new Error(`Trying to allocate ${obj.uuid} but place is taken by ${tileTrg.elementId}`)
    } else {
      tileTrg?.setElement(obj)
    }
    // tileTrg?.setElement(obj, target)
    return success
  },
  removeObjectFromTerrain: (obj: Object3D) => {
    API.removeElementFromCoords(obj.userData.coords)
  },
  removeElementFromCoords: (coords: Vector2) => {
    const grid = useScenesStore.getState().getGameElement('gridElement')
    const tileTrg = grid?.userData.grid[coords.x][coords.y] as Tile
    tileTrg?.clearTile()
  },
  coordsToPosition: (coords: Vector2) => {
    const gridOrigin = useSceneStore.getState().terrain.data.gridOrigin
    return coordsToPosition(coords, gridOrigin)
  },
  coordsAreInRange: (coords: Vector2, grid: [][]) => {
    return coords.x >= 0 && coords.x < grid.length && coords.y >= 0 && coords.y < grid[0].length
  },
  getElementAt: (coords: Vector2) => {
    const gridElement = useScenesStore.getState().getGameElement('gridElement')
    const grid = gridElement?.userData.grid as [][]
    if (API.coordsAreInRange(coords, grid)) {
      const tile = grid[coords.x][coords.y] as Tile
      if (tile?.elementId && tile?.elementId !== 'reservation') {
        return getGameElementByUUID(tile.elementId)
      }
      return null
    }
  },
  reserveTarget: (coords: Vector2) => {
    const grid = useScenesStore.getState().getGameElement('gridElement')
    const tileTrg = grid?.userData.grid[coords.x][coords.y] as Tile
    // grid tile occupation needs to be inmediately and new Game Element is not.
    // (this script will update Zustand state and trigger refresh of TerrainController, draw Gravestone and set final GameObject)
    // then, we create a new object with a special key = reservation.
    // it will fill a tile in terrain but is ignore as a GameElement.
    const reservationObject = new Object3D()
    reservationObject.userData.key = 'reservation'
    tileTrg?.setElement(reservationObject)
  },
  dropGrave: (coords: Vector2) => {
    useSceneStore.getState().terrain.addGravestone(coords)
  },
  destroyGravestone: (coords: Vector2) => {
    const grid = useScenesStore.getState().getGameElement('gridElement')
    const tileTrg = grid?.userData.grid[coords.x][coords.y] as Tile
    tileTrg?.clearTile()
    useSceneStore.getState().terrain.removeGravestone(coords)
  },
}
const TerrainController = () => {
  const gravestones = useSceneStore(SEL_GRAVESTONES)
  const gridOrigin = useSceneStore(s => s.terrain.data.gridOrigin)
  return (
    <>
      <GameElement
        name="gridElement"
        onStart={obj => {
          // boot grid
          const grid = useSceneStore.getState().terrain.data.grid
          obj.userData.grid = grid.map((row, x) => row.map((v, y) => new Tile(x, y)))
          useSceneStore.getState().levels.checkItemToGo('gridElement')
        }}
      >
        <Grid />
      </GameElement>
      {gravestones.map((grCoords: Vector2) => (
        <GameElement
          key={`gravestone_at_${grCoords.x}_${grCoords.y}`}
          name={`gravestone_${grCoords.x}_${grCoords.y}`}
          rotation={[0, -Math.PI / 4, 0]}
          position={coordsToPosition(grCoords, gridOrigin)}
          onStart={(obj: Object3D) => {
            const grid = useScenesStore.getState().getGameElement('gridElement')
            const tileTrg = grid?.userData.grid[grCoords.x][grCoords.y] as Tile
            tileTrg?.setElement(obj)
          }}
        >
          <Gravestone scale={[0.75, 0.75, 0.75]} />
        </GameElement>
      ))}
      <mesh rotation={[-Math.PI/2, 0, 0]} position={[0, -0.9, 0]}>
        <meshBasicMaterial>
          <GradientTexture
            stops={[0, 1]} // As many stops as you want
            colors={['#362766', '#24223b']} // Colors need to match the number of stops
            // colors={['#340c7d', '#2b0e5e']} // Colors need to match the number of stops
            size={1024} // Size is optional, default = 1024
          />
        </meshBasicMaterial>
        {/* <meshBasicMaterial color={0x340c7d} /> */}
        <circleGeometry args={[10, 8]} />
      </mesh>
      <mesh rotation={[-Math.PI/2, 0, 0]} position={[0, -0.95, 0]}>
        <meshBasicMaterial>
        <GradientTexture
            stops={[0, 1]} // As many stops as you want
            colors={['#01061a', '#24223b']} // Colors need to match the number of stops
            // colors={['#01061a', '#2b0e5e']} // Colors need to match the number of stops
            size={1024} // Size is optional, default = 1024
          />
        </meshBasicMaterial>
        <circleGeometry args={[15, 8]} />
      </mesh>
    </>
  )
}

export default TerrainController
